import React, { useEffect, useState } from "react";
import { ListingTable } from "components/listing";
import { FormCheckbox } from "components/form-fields";
import PropTypes from "prop-types";

const defaultArray = [];

export function PermissionsSelector({
    permissions = defaultArray,
    handlePermissionChange = () => {}
}) {
    const headers = ["role", "description", "selected"];

    const [tableRows, setTableRows] = useState([]);

    useEffect(() => {
        setTableRows(
            permissions.map((permission) => {
                return [
                    <span className="bold" key={`${permission.id}-role`}>
                        {permission.role}
                    </span>,
                    permission.description,
                    <div
                        key={`${permission.id}-checked`}
                        className="text-align-center"
                    >
                        <FormCheckbox
                            checked={permission.selected}
                            identifier={permission.id}
                            onChange={handlePermissionChange}
                        />
                    </div>
                ];
            })
        );
    }, [permissions]);

    return (
        <>
            <h3>Additional Permissions</h3>

            <p>
                All Licence Checking users will be able to view data according
                with their location permissions as well as set up policies
                according to their existing user role. For additional
                permissions please select from the below.
            </p>

            <ListingTable
                id="licence-checking-edit-users-modal"
                headers={headers}
                data={tableRows}
                totalRecordCount={tableRows.length}
                showPerPage={false}
                loadingData={false}
                pageable={false}
            />
        </>
    );
}

PermissionsSelector.propTypes = {
    permissions: PropTypes.array.isRequired,
    handlePermissionChange: PropTypes.func,
};
